import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';

interface User {
  id: string;
  name: string;
  email: string;
  token: string;
  tenant: string;
  // add other user properties as needed
}

interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  isLoading: boolean;
  error: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const authState = useAuth();
  // Transform AccountInfo to User if present
  let user: User | null = null;
  if (authState.user) {
    user = {
      id: authState.user.homeAccountId || '',
      name: authState.user.name || '',
      email: authState.user.username || '',
      token: authState.user.idToken || '',
      tenant: authState.user.tenantId || '',
      // add other user properties as needed
    };
  }
  const contextValue: AuthContextType = {
    isAuthenticated: authState.isAuthenticated,
    user,
    isLoading: authState.isLoading,
    error: authState.error,
  };
  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};
